require('./watchList.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { withRouter } = require('react-router-dom');

// @commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKIconButton } = require('commonsComponents/OKIconButton');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('commonsComponents/OKButton');
const { OKInput } = require('commonsComponents/OKInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @components
const Flag = require('components/broker/commons/flag/flag');
const SortArrows = require('../sortArrows/sortArrows');
const BrokerMiFIDUSPersonButton = require('mifid/components/brokerMiFIDUSPersonButton/brokerMiFIDUSPersonButton');
const BrokerMiFIDUSPersonLinkButton = require('mifid/components/brokerMiFIDUSPersonLinkButton/brokerMiFIDUSPersonLinkButton');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatAmountObject, formatWithoutRound } = require('utilities/currencyHelper');
const { getPublicSitePathByLanguaje } = require('core/apiURLBuilder');

// @constants
const MICCODE_CONVERSION = require('constants/miccodes');

const {
    BROKER_HIRE_PENSION_PLAN_URL,
    BROKER_SMALL_FLAG_SIZE,
    EURO_TEXT,
    MAX_PRODUCT_COUNT,
    LIST_NAME_MAX_LENGTH,
    TYPE_STOCK,
	TYPE_PLAN,
	TYPE_FUND,
	TYPE_ETF,
    TYPE_WARRANT,
    INITIAL_WATCHLIST_EDIT_ID
} = require('../constant');
const { MYPROFILE_BROKER_EXPLORE_URL } = require('constants/index');

class WatchList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: props.isExpanded,
            name: props.listData.get('name'),
            products: props.listData.get('products'),
            listErrorFlag: false
        };

        this.handleBoxClick = this.handleBoxClick.bind(this);
        this.handleTitleEdit = this.handleTitleEdit.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleEditList = this.handleEditList.bind(this);
        this.handleDeleteList = this.handleDeleteList.bind(this);
        this.handleDeleteProduct = this.handleDeleteProduct.bind(this);
        this.handleStarClicked = this.handleStarClicked.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleSearchLinkClick = this.handleSearchLinkClick.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { hasAbondantChanges, editWatchListError } = this.props;
        const {hasAbondantChanges: hasAbondantChangesNext, editWatchListError: editWatchListErrorNext} = nextProps
        const shouldCallCancel = hasAbondantChangesNext !== hasAbondantChanges  && hasAbondantChangesNext ||
            editWatchListError !== editWatchListErrorNext  && editWatchListErrorNext;

        if (shouldCallCancel) {
            this.handleCancelClick();
        }
    }

    handleBoxClick(isExpanded) {
        this.setState({
            expanded: isExpanded
        });
        if (!isExpanded) {
            this.handleCancelClick();
        }
    }

    handleTitleEdit(evt) {
        const { listData } = this.props;
        const nameValue = evt.target.value;
        this.props.setListName(nameValue !== listData.get('name'))
        this.setState({
            name: nameValue,
            listErrorFlag: false
        });
    }

    handleCancelClick() {
        const { listData, setEditId } = this.props;
        setEditId(INITIAL_WATCHLIST_EDIT_ID);
        this.setState({
            name: listData.get('name'),
            products: listData.get('products'),
            listErrorFlag: false
        });
    }

    findProduct(products, isin){
        return products.findIndex(product => product.get('isin') === isin);
    }

    handleDeleteProduct(isin, unChecked) {
        const { products } = this.state;
        const indexToBeDeleted = this.findProduct(products, isin);
        this.setState({
            products: products.setIn([indexToBeDeleted, 'unChecked'], unChecked)
        });
    }

    handleRemoveProducts(isin) {
        const { products } = this.state;
        this.setState({
            products: products.filter(product => product.get('isin') !== isin)
        });
    }

    handleStarClicked(isin, unChecked) {
        const { isTitleEditable, listData, onHandleDeleteProduct, setListName, handleAddToExistingList } = this.props;
        this.handleDeleteProduct(isin, !unChecked);
        if (isTitleEditable) {
            setListName(true);
        } else {
            const id = listData.get('id');
            const listName = listData.get('name');
            const product = listData.get('products').find((product) => product.get('isin') === isin);
            const micCode = product.get('micCode') || product.get('dgsCode');
            const productName = product.get('name');
            const productType = product.get('type');
            const productKey = product.get('productKey');

            if (unChecked){
                handleAddToExistingList(id, isin, micCode, listName, productType, true)
            } else {
                onHandleDeleteProduct(id, isin, micCode, productName, !unChecked, true, productType, productKey);
            }
        }
    }

    handleSaveClick() {
        const { requestEditWatchList, setEditId , listData, watchlistContent } = this.props;
        const { name, products } = this.state;
        const currentListId = listData.get('id');
        let listError = false;
        watchlistContent.map((content) => {
            if (name.toLowerCase() === content.get('name').toLowerCase() && currentListId !== content.get('id')) {
                listError = true;
            }
        });
        if (!listError) {
            setEditId(INITIAL_WATCHLIST_EDIT_ID);
            requestEditWatchList(name, listData, products);
        } else {
            this.setState({
                listErrorFlag: true
            });
        }
    }


    handleEditList(handlerToggle) {
        const { toggleModal, setEditId, listData } = this.props;
        const listId = listData.get('id');
        const canProceed = toggleModal('discard', listId);
        !canProceed && setEditId(listId);
        !canProceed && !this.state.expanded && handlerToggle();
    }

    handleDeleteList() {
        const { onDeleteWatchList, listData } = this.props;
        onDeleteWatchList(listData.get('id'));
    }

    createListTitle(listData) {
        const { name, listErrorFlag } = this.state;
        const { isTitleEditable } = this.props;
        const instructionsList = [
            'brokerWatchList-brokerWatchList_watchListNameInstruction1',
            'brokerWatchList-brokerWatchList_watchListNameInstruction2',
            'brokerWatchList-brokerWatchList_watchListNameInstruction3',
        ];
        let titleElement, errorMsg;
        if (listErrorFlag) {
            errorMsg = <FormattedText value="brokerWatchList-brokerWatchlist_listErrorMessage" injectedStrings={[name]}/>
        }
        if (isTitleEditable) {
            const tooltipInstructions = instructionsList.map((value, index)=>(
                <li key={index} className="watch-list__guide-list-item">
                    {formatText(value, [LIST_NAME_MAX_LENGTH])}
                </li>
            ));
            const iconHelpTooltipText = (
                <ul className="watch-list__edit-name-guide-list">
                    {tooltipInstructions}
                </ul>
            );

            titleElement = (
                <span>
                    <OKInput
                        value={name}
                        onChange={this.handleTitleEdit}
                        autoComplete="off"
                        maxLength={LIST_NAME_MAX_LENGTH}
                        errorState={listErrorFlag}
                        errorMessage={errorMsg}
                    />
                    <span className="watch-list__title-tooltip">
                        <OKTooltip
                            content={iconHelpTooltipText}
                            placement="top"
                        />
                    </span>
                </span>
            );
        } else {
            titleElement = (
                <span>
                    <span className="watch-list__title">
                        {name}
                    </span>
                    <span className="watch-list__products-number">
                        &nbsp;{formatText('brokerWatchList-brokerWatchList_productCounts', [
                            listData.get('products') && listData.get('products').size,
                            MAX_PRODUCT_COUNT
                        ])}
                    </span>
                </span>
            );
        }
        return titleElement;
    }

    ListHeader(newProps) {
        const {
            disabled,
            isTitleEditable,
            onHandleEditList,
            onHandleDeleteList,
            listTitle,
            handlerToggle
        } = newProps;

        const headerClasses = classNames('watch-list__header', {
            'watch-list__header--disabled': disabled
        })
        return (
            <div className={headerClasses}>
                {listTitle}
                <div className="watch-list__header-buttons">
                    {
                        !isTitleEditable && (
                            <span className="watch-list__edit-buttons">
                                <OKIconButton
                                    size="small"
                                    icon="icon-editar"
                                    accordionButton={true}
                                    disabled={disabled}
                                    onClick={()=>{
                                        onHandleEditList(handlerToggle)
                                    }}
                                />
                            </span>
                        )
                    }
                    <OKIconButton
                        size="small"
                        icon="icon-eliminar"
                        disabled={disabled}
                        onClick={onHandleDeleteList}
                    />
                </div>
            </div>
        );
    }

    handleSort(sortBy, id, order) {
        this.props.sortWatchList(sortBy, id, order);
        this.setState({
            products: this.state.products.sort((product1, product2) => {
                // need to check for name sorting: 1) 2) => reducer
                const modifiedItem1 = product1.get(sortBy).toString().toUpperCase();
                const modifiedItem2 = product2.get(sortBy).toString().toUpperCase();
                return  (modifiedItem1 > modifiedItem2) && (order === "down") ? 1 : -1;
            })
        });
    }

    createListBody() {
        const { isTitleEditable, disabled } = this.props;
        const listFooterLink = this.createFooterLink();
        const listFooterButtons = isTitleEditable && this.createFooterButtons();
        const disabledElement = disabled && (
            <div className="watch-list__disable-cover"></div>
        );
        const listBodyClasses = classNames('watch-list__body', {
            'watch-list__body--disabled': disabled
        });
        return (
            <div className={listBodyClasses}>
                <OKTable>
                    <thead>
                        <OKTableRow className="watch-list__table-head" asHeader={true} modifier="inner-padding">
                            <OKTableCell
                                asHeader={true}
                                className="watch-list__table-col watch-list__table-col--name"
                            >
                                <div className="watch-list__table-sortarrows">
                                    <FormattedText value="brokerWatchList-brokerWatchList_productName"/>
                                    <SortArrows
                                        listId={this.props.listData.get('id')}
                                        onHandleSort={this.handleSort}
                                        sortKey={"name"}
                                    />
                                </div>
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="watch-list__table-col watch-list__table-col--value"
                            >
                                <FormattedText value="brokerWatchList-brokerWatchList_quotationValue"/>
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="watch-list__table-col watch-list__table-col--variation"
                            >
                                <FormattedText value="brokerWatchList-brokerWatchList_variation"/>
                                <SortArrows
                                    listId={this.props.listData.get('id')}
                                    onHandleSort={this.handleSort}
                                    sortKey={"variation"}
                                />
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="watch-list__table-col watch-list__table-col"
                            >
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                    <tbody>
                        {this.createListTableBody()}
                    </tbody>
                </OKTable>
                {listFooterButtons}
                {listFooterLink}
                {disabledElement}
            </div>
        );
    }

    createMarketDescriptionAndFileUrl(product) {
        const { disabled } = this.props;
        let market;
        const MICCode = product.get('micCode') && product.get('micCode').trim();
        const DGSCode =  product.get('dgsCode') && product.get('dgsCode').trim();
        const ISINCode = product.get('isin') && product.get('isin').trim();
        const tickerCode = product.get('ticker') && product.get('ticker').trim();
        const CustomInstitutionSecurityID = product.get('CustomInstitutionSecurityID') &&
            product.get('CustomInstitutionSecurityID').trim();

        let flag, marketCity, marketCountryCode;

        if (!!MICCode) {
            market = MICCODE_CONVERSION.find(currentMarket => currentMarket.MIC == MICCode);
            marketCity = market && market.CITY;
            marketCountryCode = market && market.ISO_COUNTRY_CODE;
            const countryCode = market && market.ISO_COUNTRY_CODE;
            flag = <Flag countryCode={countryCode} pixelsSize={BROKER_SMALL_FLAG_SIZE}/>
        }

        let productType = product.get('type');
        productType = productType && productType.toLowerCase();
        let marketDescription, fileUrl, buyUrl;
        switch(productType) {
            case TYPE_STOCK:
                marketDescription = <span>{flag}&nbsp;{marketCity}, {marketCountryCode} | {tickerCode}</span>;
                fileUrl = `/myprofile/broker/productFile/${ISINCode}/${MICCode}`;
                buyUrl = `/myprofile/broker/stocksBuy/${ISINCode}/${MICCode}`;
                break;
            case TYPE_ETF:
                marketDescription = <span>{flag}&nbsp;{marketCity}, {marketCountryCode} | {tickerCode}</span>;
                fileUrl = `/myprofile/broker/etfsProductFile/${ISINCode}/${MICCode}`;
                buyUrl = `/myprofile/broker/etfsBuy/${ISINCode}/${MICCode}`;
                break;
            case TYPE_WARRANT:
                fileUrl = `/myprofile/broker/warrantsProductFile/${ISINCode}/${MICCode}`;
                buyUrl = `/myprofile/broker/warrantsBuy/${ISINCode}/${MICCode}`;
                marketDescription = <span>{flag}&nbsp;{marketCity}, {marketCountryCode} | {ISINCode}</span>;
                break;
            case TYPE_FUND:
                fileUrl = `/myprofile/broker/fund/isin/${ISINCode}`;
                buyUrl = `/myprofile/broker/buyInvestmentFunds/${CustomInstitutionSecurityID}`
                marketDescription = <span>{ISINCode}</span>;
                break;
            case TYPE_PLAN:
                fileUrl = getPublicSitePathByLanguaje('brokerURL-brokerURL_pensionPlanOnPublic', {DGSCode})
                buyUrl = BROKER_HIRE_PENSION_PLAN_URL + CustomInstitutionSecurityID;
                marketDescription = <span>{DGSCode}</span>;
                break;
            default:
                marketDescription = <span>{ISINCode}</span>;
        }

        if (disabled) {
            flag = <Flag countryCode=" " pixelsSize={BROKER_SMALL_FLAG_SIZE}/>;
            marketDescription = (
                <span>
                    {flag}&nbsp;
                    <FormattedText value="brokerWatchList-emptyStateTicker"/>
                </span>
            );
        }

        return {
            marketDescription,
            fileUrl,
            buyUrl
        }
    }

    createListTableBody() {
        const { disabled, listData, listSelectedForParam } = this.props;
        const { products } = this.state;
        const watchlistId = listData.get('id');

        let tableBody;
        if (products.size !== 0) {
            tableBody = products.map((product, index) => {
                const formattedAmountObject = formatAmountObject({
                    amount: product.get('quote') || 0,
                    currency: product.get('currency') || EURO_TEXT,
                    decimalsLength: 4
                });
                const variation = product.get('variation') || 0;
                const variationType = variation >= 0 ? 'up' : variation < 0 ? 'down' : '';
                const arrowClasses = classNames('watch-list__arrow', {
                    'icon-alza': variationType === 'up',
                    'icon-baja': variationType === 'down',
                    'watch-list__arrow--up': variationType === 'up',
                    'watch-list__arrow--down': variationType === 'down',
                    'watch-list__arrow--disabled': disabled
                });
                const marketDescriptionAndFileUrl = this.createMarketDescriptionAndFileUrl(product);
                const marketDescription = marketDescriptionAndFileUrl['marketDescription'];
                const fileUrl = marketDescriptionAndFileUrl['fileUrl'];
                const buyUrl = marketDescriptionAndFileUrl['buyUrl'];
                const isin = product.get('isin') && product.get('isin').trim();
                const MICCode = product.get('micCode') && product.get('micCode').trim();
                const starIconClasses = classNames('watch-list__star', {
                    'watch-list__star--disabled': disabled || product.get('unChecked')
                });
                const buyLabel = formatText(`broker-searchResultsWatchListBuyLabel`);
                let productType = product.get('type');
                productType = productType && productType.toLowerCase();
                let buyButton;
                if(productType === TYPE_FUND) {
                    buyButton = (
                        <BrokerMiFIDUSPersonLinkButton
                            modifier="secondary"
                            to={buyUrl}
                            size="compact"
                            isinId={isin}
                        >
                            {buyLabel}
                        </BrokerMiFIDUSPersonLinkButton>
                    );
                } else if (productType === TYPE_PLAN) {
                    buyButton = (
                        <OKButton
                            modifier="secondary"
                            to={buyUrl}
                            size="compact"
                        >
                            {buyLabel}
                        </OKButton>
                    );
                } else {
                    buyButton = (
                        <BrokerMiFIDUSPersonButton
                            modifier="secondary"
                            onClick={() => this.props.onHandleStockContractClick(buyUrl)}
                            size="compact"
                            isinId={isin}
                            marketId={MICCode}
                        >
                            {buyLabel}
                        </BrokerMiFIDUSPersonButton>
                    );
                }

                return (
                    <OKTableRow key={index}>
                        <OKTableCell className="watch-list__table-col watch-list__table-col--name">
                            <span className="watch-list__product-name">
                                <OKLink to={fileUrl}>{product.get('name') || ''}</OKLink>
                            </span>
                            <div>
                                {marketDescription}
                            </div>
                        </OKTableCell>
                        <OKTableCell className="watch-list__table-col watch-list__table-col--value">
                            {formattedAmountObject.amount}&nbsp;{formattedAmountObject.currencyCode}
                        </OKTableCell>
                        <OKTableCell className="watch-list__table-col watch-list__table-col--variation">
                            <i className={arrowClasses}></i>
                            {variation !== 0 ? formatWithoutRound(variation, 2): variation} %
                        </OKTableCell>
                        <OKTableCell className="clearfix watch-list__table-col-buttons">
                            <span className="pull-left watch-list__favourite-button">
                                <OKButton
                                    modifier="ghost"
                                    size="small"
                                    autoHeight={true}
                                    onClick={() => {
                                        if (!disabled) {
                                            this.handleStarClicked(isin, product.get('unChecked'));
                                        }
                                    }}
                                >
                                    <i className={starIconClasses}></i>
                                </OKButton>
                            </span>
                            <span className="pull-left watch-list__buy-button">
                                {buyButton}
                            </span>
                        </OKTableCell>
                    </OKTableRow>
                );
            });
        } else {
            tableBody = (
                <OKTableRow>
                    <OKTableCell colSpan="4">
                        <div className="watch-list__empty-state">
                            <i className="icon watch-list__empty-icon empty-state-noitems-wealth"/>
                            <FormattedText value="brokerWatchList-brokerWatchList_emptyListText"/>
                            <OKLink
                                modifier="emphasize"
                                to={MYPROFILE_BROKER_EXPLORE_URL}
                                onClick={() => {
                                    listSelectedForParam(watchlistId);
                                }}
                            >
                                <FormattedText format="lowercase" value="brokerWatchList-brokerWatchList_addProductLinkText" />
                            </OKLink>
                        </div>
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return tableBody;
    }

    createFooterButtons() {
        return (
            <div className="watch-list__footer-buttons clearfix">
                <span className="pull-left">
                    <OKButton modifier="link-ghost" onClick={this.handleCancelClick}>
                        <FormattedText value="brokerWatchList-brokerWatchList_cancelButton"/>
                    </OKButton>
                </span>
                <span className="pull-right">
                    <OKButton onClick={this.handleSaveClick}>
                        <FormattedText value="brokerWatchList-brokerWatchList_saveButton"/>
                    </OKButton>
                </span>
            </div>
        );
    }

    handleSearchLinkClick(listName, watchlistId) {
        const { name } = this.state;
        const { history, isTitleEditable, toggleModal, listSelectedForParam } = this.props;
        if (name !==listName && isTitleEditable) {
            toggleModal();
        } else {
            listSelectedForParam(watchlistId);
            history.push(MYPROFILE_BROKER_EXPLORE_URL);
        }
    }

    createFooterLink() {
        const { listData } = this.props;
        const numberOfProducts = listData.get('products').size;
        const watchlistId = listData.get('id');
        const listName = listData.get('name');
        const disabledElement = numberOfProducts >= MAX_PRODUCT_COUNT && (
            <div className="watch-list__disable-cover"></div>
        );

        return (
            <div className="watch-list__footer">
                {disabledElement}
                <OKLink modifier="widget" onClick={() => this.handleSearchLinkClick(listName, watchlistId)}>
                    <FormattedText value="brokerWatchList-brokerWatchList_addProductLinkText"/>
                </OKLink>
            </div>
        );
    }

    render() {
        const { isTitleEditable, disabled, listData, isExpanded } = this.props;
        const { expanded } = this.state;
        const listClasses = classNames('watch-list', {
            'watch-list--expanded': isTitleEditable || expanded,
            'watch-list--disabled': disabled
        });

        return (
            <div className={listClasses}>
                <Accordion
                    onClick={this.handleBoxClick}
                    isExpanded={isExpanded}
                >
                    <AccordionHeader name="AccordionHeader">
                        <this.ListHeader
                            listTitle={this.createListTitle(listData)}
                            isTitleEditable={isTitleEditable}
                            onHandleEditList={this.handleEditList}
                            onHandleDeleteList={this.handleDeleteList}
                            disabled={disabled}
                        />
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        {this.createListBody()}
                    </AccordionBody>
                </Accordion>
            </div>
        );
    }
}

WatchList.propTypes = {
    disabled: PropTypes.bool,
    editWatchListError: PropTypes.bool,
    hasAbondantChanges: PropTypes.bool,
    handleAddToExistingList: PropTypes.func.isRequired,
    isExpanded: PropTypes.bool,
    isRefreshed: PropTypes.bool,
    isTitleEditable: PropTypes.bool,
    listData: PropTypes.object.isRequired,
    listSelectedForParam: PropTypes.func,
    onDeleteWatchList: PropTypes.func.isRequired,
    onHandleDeleteProduct: PropTypes.func.isRequired,
    onHandleStockContractClick: PropTypes.func.isRequired,
    requestEditWatchList: PropTypes.func.isRequired,
    setEditId: PropTypes.func,
    setListName: PropTypes.func,
    sortWatchList: PropTypes.func,
    toggleModal: PropTypes.func.isRequired,
    watchlistContent: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

WatchList.defaultProps = {
    disabled: false,
    editWatchListError: null,
    hasAbondantChanges: false,
    isExpanded: false,
    isRefreshed: false,
}

module.exports = withRouter(WatchList);
